<template>
  <b-form-group>
    <b-input-group>
      <b-input
        :value="value"
        placeholder="Type to Search"
        @input="$emit('input', $event)"
      />
      <b-input-group-append>
        <b-button
          :disabled="!value"
          variant="primary"
          @click="$emit('clear')"
        >
          Clear
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  value: {
    type: String,
    required: true,
  },
}

@Component
export default class FilterSearch extends Vue.extend({ props }) {}

</script>
